export const clientsRow1 = [
    { name: 'Adarsh Group', logo: '/clients/adarsh.png' },
    { name: 'Axis Bank', logo: '/clients/axisbank.png' },
    { name: 'Axis Concept Construction Pvt Ltd', logo: '/clients/axisc.png' },
    { name: 'NCC Limited', logo: '/clients/ncc.png' },
    { name: 'T.G Developer', logo: '/clients/tg-developers.png' },
    { name: 'Raghuram Infrastructure Co Pvt Ltd', logo: '/clients/raghuram.png' },
    { name: 'Prestress Steel LLP', logo: '/clients/prestress.png' },
    { name: 'Sre Kateel Industries', logo: '/clients/sre.png' },
    { name: 'Clayworks Spaces Pvt Ltd.', logo: '/clients/clayworks.png' },
];

export const clientsRow2 = [
    { name: 'Nine Star Suzuki', logo: '/clients/suzuki.png' },
    { name: 'TVS', logo: '/clients/tvs.png' },
    { name: 'Vivo', logo: '/clients/vivo.png' },
    { name: 'Synergy Autokraft' },
    { name: 'Vsmart World Communication Pvt. Ltd.' },
    { name: 'Samaskruti Brindavan Convention Centre & Gokula' },
    { name: 'S.V Convention Centre' },
    { name: 'Chamraju Kalyan Mandappa' },
    { name: 'Venu Park Convention Centre' },
    { name: 'Mahaveer Group', logo: '/clients/mahaveer.png' },
];

export const allClients = [...clientsRow1, ...clientsRow2];
